import { useState, useEffect } from "react";

import { CheckCircle } from "@mui/icons-material";
// import SearchBox from "../../components/SearchBox";
// import MembersList from "../../components/MembersList";
// import { SetExpirationModal } from "../../molecules/AppModal";
import { useMemberState } from "../../contexts/membercontext";
// import { useResourceState } from "../../contexts/kitchencontext";
import {useLoadCommunity} from "../../hooks/authhooks"; 
import { useLoadMemberships } from "../../hooks/memberhooks";
// import { useLoadPlans, useLoadRequirements, useResourceHook } from "../../hooks/resourcehooks";
import EditMultipleMembers from '../../molecules/EditMultipleMembers'
// import NewSearch from "../../molecules/NewSearch";
// import { ReactComponent as KitchenIcon } from '../../icons/KitchenIcon.svg'
import { CommunityOptionType, DSCommunitySchema, ResourceSchema, ReviewSchema } from "../../data/types";
// import { AddCircle } from "@mui/icons-material";
import { getChangedAttributes } from "../../utils/helpers";
import {  usStates, USStatesEnum } from "../../utils/enums";
import { useAuthState } from '../../contexts/authcontext'
// import { ReactComponent as EditProfileIcon } from '../../icons/EditProfileIcon.svg'
// import { ReactComponent as AddImageIcon } from '../../icons/AddImageIcon.svg'
import { CustomAddImageBox } from '../../components/AddImageBox'
// import { CommunityRequirementsForm } from "../../molecules/forms";
// import { AllMemberRequests } from "./RequestsPage";
import { ConfirmationModal } from "../../molecules/AppModal";
import LoadingScreen from "../shared/LoadingScreen";
import FocusGroupInsightsPage from "../focus-groups/FocusGroupInsightsPage";
import { ReactComponent as ReviewIcon } from '../../icons/ReviewIcon.svg';
import { toast } from "sonner";
import CompliancePage from '../../components/compliance/CompliancePage';





const CommunityPage = () => {

  var { authUser } = useAuthState()
  var communityId = (authUser && authUser.primary_community) ? authUser.primary_community : ""
  var { primaryCommunity } = useLoadCommunity(communityId)

  var { memberships } = useLoadMemberships();
  const { membershipRequests, addingMembers, setAddingMembers } = useMemberState();
  const [currentOption, setCurrentOption] = useState<CommunityOptionType>({id: "setup-checklist", name: "Setup Checklist"});

  const closeAppModal = () => {
    setAddingMembers(false)
  };

  const communityOptions = [
    {
      id: "setup-checklist",
      name: "Setup Checklist"
    },
    {
      id: "details",
      name: "Community Details"
    },
    {
      id: "images",
      name: "Logo and Images"
    },
    // {
    //   id: "plans",
    //   name: "Plans"
    // },
    // {
    //   id: "requirements",
    //   name: "Requirements"
    // },
    // {
    //   id: "memberships",
    //   name: "Memberships"
    // },
    {
      id: "reviews",
      name: "Reviews"
    },
    {
      id: "data-insights",
      name: "Data Insights"
    }
  ]


  const [currentCommunity, setCurrentCommunity] = useState<DSCommunitySchema>(primaryCommunity as DSCommunitySchema)
  // const [isOpenPlan, setIsOpenPlan] = useState<boolean>(false);
  // const { memberships } = useLoadMemberships();
  // const { membershipRequests } = useLoadRequests();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target
    if (name && (value || value === "")){
      setCurrentCommunity(prev => (
        {
          ...prev,
          [name]: value
        }
      ))
    }
  }

  useEffect(() => {
    document.title = `HomeCook | ${currentOption.name}`;
    // eslint-disable-next-line
  }, [memberships, membershipRequests]);

  return addingMembers ? (
    <div className="md:p-[3%] w-full bg-back-400 pt-16 md:pt-16 font-open-sans flex flex-col gap-10">
      <div>
        <h1 className="text-3xl font-bold text-center justify-self-center">Add New Member Details</h1>
        <h1 className="text-md text-center justify-self-center">Include plans & other membership details for new members.</h1>
      </div>
      <EditMultipleMembers closeAppModal={closeAppModal} cancelEditMember={() => setAddingMembers(false)}/>
    </div>
  ) : (
    <div className="page-canvas h-auto">
      <div className="flex flex-row bg-white h-[75px] w-full">
        {
          communityOptions.map((option, i) => {
            return (
              <div 
                key={i} 
                onClick={()=>setCurrentOption(option)} 
                className={`${(currentOption.id === option.id) ? 'text-white bg-primary-200 font-medium' : 'text-[#4D4D4D] '} ml-6 my-auto text-[16px] font-raleway border-[1px] border-[#E9E9E9] py-2 px-4 rounded-md cursor-pointer`}
              >
                  {option.name}
              </div>
            )
          })
        }
      </div>
      {
        (currentOption.id === "details") ? (<CommunityDetails currentCommunity={primaryCommunity as DSCommunitySchema} community={currentCommunity} handleChange={handleChange} />) : (
              (currentOption.id === "images") ? (<LogoAndImages currentCommunity={primaryCommunity as DSCommunitySchema} community={currentCommunity} handleChange={handleChange} />) : (
                (currentOption.id === "setup-checklist") ? (
                  <CompliancePage
                    community={primaryCommunity as DSCommunitySchema}
                    communityId={communityId}
                  />
                ) : (
                (currentOption.id === "data-insights") ? (<FocusGroupInsightsPage />) : (
                  <Reviews reviews={[]} />
                )
              )
            )
          )
      }

      {/* <AddPlanModal isOpen={isOpenPlan} closeAppModal={()=> setIsOpenPlan(false)} /> */}
    </div>
  );
};


type CommunityDetailsProps = {
  community: DSCommunitySchema
  currentCommunity: DSCommunitySchema
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void
}

const CommunityDetails: React.FC<CommunityDetailsProps> = ({community, currentCommunity, handleChange}) => {
  const communityId = community?.id ? community.id : ""
  var { updateCommunityDetails, isUpdateSuccess, isUpdateError, isUpdatePending } = useLoadCommunity(communityId)
  const [isConfirmBoxOpen, toggleConfirmBox] = useState<boolean>(!isUpdatePending && (isUpdateSuccess || isUpdateError))

  const handleSaveChanges = () => {
    var changes = getChangedAttributes<DSCommunitySchema>(currentCommunity as DSCommunitySchema, community as DSCommunitySchema);
    // console.log("changes", changes)
    if (Object.keys(changes).length > 0){
      updateCommunityDetails(communityId, changes)
    }
    if(isUpdateError) {
      toast.error("Failed to update community details. Please try again.");
    }else{
      toast.success("Community details updated successfully.");
    }

  }


  const zipCodeRegex = /^\d{5}(-\d{4})?$/;

  useEffect(() => {
    document.title = "HomeCook | Community Details";
    // eslint-disable-next-line
  }, [community]);
  return (isUpdatePending) ? (
    <LoadingScreen />
  ) : (
    <>
      <div className="flex flex-row bg-white h-[75px] w-full border-t-[#E6E6E6] border-t-[1px]">
        <p className="mx-[24px] my-auto font-open-sans text-[16px] text-[#4D4D4D]/70">
            View and edit your community details.
        </p>
        {
          (
            ((community?.name !== undefined && currentCommunity?.name !== undefined) && (community?.name !== currentCommunity?.name)) ||
            ((community?.description !== undefined && currentCommunity?.description !== undefined ) && (community?.description !== currentCommunity?.description)) ||
            ((community?.address !== undefined && currentCommunity?.address !== undefined) && (community?.address !== currentCommunity?.address)) ||
            ((community?.city !== undefined && currentCommunity?.city !== undefined) && (community?.city !== currentCommunity?.city)) ||
            ((community?.state !== undefined && currentCommunity?.state !== undefined) && (community?.state !== currentCommunity?.state)) ||
            ((community?.zipcode !== undefined && currentCommunity?.zipcode !== undefined && zipCodeRegex.test(currentCommunity?.zipcode)) && (community?.zipcode !== currentCommunity?.zipcode)) ||
            ((community?.website !== undefined && currentCommunity?.website !== undefined) && (community?.website !== currentCommunity?.website))
          ) ? (
            <div className="flex ml-auto mx-[24px] h-auto">
              <button
                className="text-primary-200 h-[43px] px-2 border-[1px] border-[#E9E9E9] ml-auto rounded-lg my-auto"
                onClick={handleSaveChanges}
              >
                Save Changes
              </button>
            </div>
          ) : (
            <></>
          )
        }
      </div> 
      
      <div className="flex flex-col w-11/12 mx-auto">
        <div className="flex flex-col bg-white my-3 h-[178px] w-full rounded-lg">
          <div className="m-[24px] my-auto">
            <p className="text-[#808080] text-[16px] font-raleway my-2">Community Name</p>
            <input name="name" onChange={handleChange} className="border-[#E9E9E9] h-[51px] border-[1px] w-full rounded-md" value={community?.name} />
          </div>
        </div>

        <div className="flex flex-col bg-white my-3 h-[247px] w-full rounded-lg">
          <div className="m-[24px] my-auto">
            <p className="text-[#808080] text-[16px] font-raleway my-2">Community Description</p>
            <textarea name="description"  onChange={handleChange} className="border-[#E9E9E9] h-[120px] border-[1px] w-full rounded-md" value={community?.description} />
          </div>
        </div>

        <div className="flex flex-row bg-white my-3 h-[178px] w-full rounded-lg">
          <div className="m-[24px] w-full my-auto">
            <p className="text-[#808080] text-[16px] font-raleway my-2">Address</p>
            <input name="address" onChange={handleChange} className="border-[#E9E9E9] h-[51px] border-[1px] w-full rounded-md" value={community?.address} />
          </div>
        </div>


        <div className="flex flex-col bg-white my-3 h-[178px] w-full rounded-lg">
          <div className='flex flex-row my-auto m-[24px]'>
            <div className='my-4 mr-1 w-1/4'>
              <p className="text-[#808080] text-[16px] font-raleway my-2">City</p>
              <input 
                type='text' 
                placeholder='Enter City' 
                className='border-[#E9E9E9] border-[1px] w-full rounded-md h-[50px] text-[16px]'
                name="city"
                value={community?.city}
                onChange={handleChange}
              />
            </div>
            <div className='my-4 mr-1 w-1/4'>
              <p className="text-[#808080] text-[16px] font-raleway my-2">State</p>
              <select 
                name="state" 
                value={community?.state} 
                className="border-[#E9E9E9] border-[1px] w-full rounded-md h-[50px] text-[16px]"
                onChange={handleChange}
              >
                <option value="">-- Select State --</option>
                <option value="nationwide">All</option>
                {
                    (usStates && usStates.length > 0) && usStates.map((state, i) => (
                        <option value={state} key={i}>{USStatesEnum[state]?.fullName}</option>
                    ))
                }
              </select>
            </div>
            <div className='my-4 w-1/4'>
              <p className="text-[#808080] text-[16px] font-raleway my-2">Zipcode</p>
              <input 
                type='text' 
                placeholder='Enter Zipcode' 
                className='border-[#E9E9E9] border-[1px] w-full rounded-md h-[50px] text-[16px]'
                name="zipcode"
                value={community?.zipcode}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>

        <div className="flex flex-row bg-white my-3 h-[178px] w-full rounded-lg">
          <div className="m-[24px] w-full my-auto">
            <p className="text-[#808080] text-[16px] font-raleway my-2">Website Link</p>
            <input name="website" onChange={handleChange} className="border-[#E9E9E9] h-[51px] border-[1px] w-full rounded-md" value={community?.website} />
          </div>
        </div>

      </div>

      <ConfirmationModal  
        isOpen={isConfirmBoxOpen} 
        message={isUpdateSuccess ? "All changes have been saved": "Update Failed"} 
        closeModal={()=>toggleConfirmBox(false)}
      />
    </>
  )
}



type LogoAndImagesProps = {
  community: DSCommunitySchema
  resource?: ResourceSchema
  currentCommunity: DSCommunitySchema
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void
}
const LogoAndImages: React.FC<LogoAndImagesProps> = ({community, currentCommunity, handleChange}) => {

  const communityId = community?.id ? community.id : ""
  var { updateCommunityDetails, isUpdateSuccess, isUpdateError, isUpdatePending } = useLoadCommunity(communityId)
  const [isConfirmBoxOpen, toggleConfirmBox] = useState<boolean>(!isUpdatePending && (isUpdateSuccess || isUpdateError))

  const [selectedLogo, setSelectedLogo] = useState(currentCommunity.logo);
  const [selectedBgPhoto, setSelectedBgPhoto] = useState(currentCommunity.bgPhoto);

  const handleSaveChanges = () => {
    community.logo = selectedLogo
    community.bgPhoto = selectedBgPhoto

    var changes = getChangedAttributes<DSCommunitySchema>(currentCommunity as DSCommunitySchema, community as DSCommunitySchema);
    // console.log("changes", changes)
    if (Object.keys(changes).length > 0){
      updateCommunityDetails(communityId, changes)
    }
  }

  useEffect(() => {
    document.title = "HomeCook | Logo & Images";
  }, []);

  return (isUpdatePending) ? (
    <LoadingScreen />
  ) : (
    <>
      <div className="flex flex-row bg-white h-[75px] w-full border-t-[#E6E6E6] border-t-[1px]">
        <p className="mx-[24px] my-auto font-open-sans text-[16px] text-[#4D4D4D]/70">
            View and edit your community logo and images.
        </p>
        {
          (
            ((currentCommunity?.bgPhoto === undefined && selectedBgPhoto !== undefined) || (selectedBgPhoto !== currentCommunity?.bgPhoto)) ||
            ((currentCommunity?.logo === undefined  && selectedLogo !== undefined) || (selectedLogo !== currentCommunity?.logo))
          ) ? (
            <div className="flex ml-auto mx-[24px] h-auto">
              <button
                className="text-primary-200 h-[43px] px-2 border-[1px] border-[#E9E9E9] ml-auto rounded-lg my-auto"
                onClick={handleSaveChanges}
              >
                Save Changes
              </button>
            </div>
          ) : (
            <></>
          )
        }
        
      </div> 
      <div className="flex flex-col w-11/12 mx-auto font-open-sans h-auto">
        <div className="flex flex-col bg-white my-3 h-[324px] w-full rounded-lg">
          <div className="flex flex-col m-[24px]">
            <p className="text-[16px] font-raleway font-semibold text-black">Upload Community Logo</p>
            <p className="text-[16px] font-open-sans font-light text-[#4D4D4D]">Upload a logo to represent your community.</p>
            <>
            <div className="flex flex-row text-2xl text-[#000] h-[206px] border-[1px] rounded-lg border-[#E9E9E9] my-4">
              <CustomAddImageBox name="logo" height="158px" width="200px" selectedImage={selectedLogo} setSelectedImage={setSelectedLogo} handleChange={handleChange} />
              <div className="flex flex-col font-open-sans text-[16px] text-[#4D4D4D] my-auto mx-2">
                <span><CheckCircle className="text-primary-400 mx-1" /> Accepted formats: JPEG (.jpg, .jpeg), PNG (.png), SVG (.svg)</span>
                <span><CheckCircle className="text-primary-400 mx-1" /> At least 500x500 pixels</span>
                <span><CheckCircle className="text-primary-400 mx-1" /> Maximum file size: 5MB</span>
                <span><CheckCircle className="text-primary-400 mx-1" /> Transparent background preferred for versatility</span>
              </div>
            </div>
            </>
          </div>
        </div>

        <div className="flex flex-col bg-white my-3 h-[324px] w-full rounded-lg">
          <div className="flex flex-col m-[24px]">
          <p className="text-[16px] font-raleway font-semibold text-black">Upload Community Images</p>
          <p className="text-[16px] font-open-sans font-light text-[#4D4D4D]">Upload clear images that showcase your community.</p>
          <div className="flex flex-row text-2xl text-[#000] w-full h-[206px] border-[1px] rounded-lg border-[#E9E9E9] my-4">
            <CustomAddImageBox name="bgPhoto" height="158px" width="340px" selectedImage={selectedBgPhoto} setSelectedImage={setSelectedBgPhoto} handleChange={handleChange} />
          </div>
          </div>
        </div>
      </div>

      <ConfirmationModal  
        isOpen={isConfirmBoxOpen} 
        message={isUpdateSuccess ? "All changes have been saved": "Update Failed"} 
        closeModal={()=>toggleConfirmBox(false)}
      />
    </>
  )
}

type ReviewsProps = {
  reviews: ReviewSchema[]
}

const Reviews: React.FC<ReviewsProps> = ({reviews}) => {

  useEffect(() => {
    document.title = "HomeCook | Reviews";
  }, []);

  if (!reviews || reviews.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[60vh] w-full">
        <div className="bg-white rounded-xl shadow-sm flex flex-col items-center px-12 py-10 max-w-md mx-auto">
          <div className="bg-[#EFF8FA]/90 rounded-full flex items-center justify-center w-20 h-20 mb-6">
            <ReviewIcon className="w-10 h-10 text-primary-400" />
          </div>
          <div className="font-raleway font-semibold text-xl text-[#013847] mb-2 text-center">
            You have no reviews yet
          </div>
          <div className="font-open-sans text-[#333333] text-md text-center max-w-xs">
            Once customers start sharing their experiences, you'll see their feedback here.
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col w-11/12 mx-auto">

    <div className="flex flex-row bg-white my-6 h-[178px] w-full rounded-md">
    </div>

    <div className="flex flex-row bg-white my-6 h-[247px] w-full rounded-md">
    </div>

    <div className="flex flex-row bg-white my-6 h-[178px] w-full rounded-md">
    </div>

    <div className="flex flex-row bg-white my-6 h-[178px] w-full rounded-md">
    </div>

    <div className="flex flex-row bg-white my-6 h-[178px] w-full rounded-md">
    </div>

    <div className="flex flex-row bg-white my-6 h-[178px] w-full rounded-md">
    </div>

  </div>
  )
}


export default CommunityPage;
